import { GeneratedBuildData } from 'web/data/models'

export const GENERATED_MAIN: GeneratedBuildData = JSON.parse(`
{
    "specsById": {
      "67a45712-192e-4916-ad57-d9a13124fea6": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "role": "Healer",
        "name": "Discipline",
        "id": "67a45712-192e-4916-ad57-d9a13124fea6",
        "shortName": "Disc",
        "icon_name": "spell_holy_powerwordshield",
        "spellIds": [
          "96c97815-252d-401a-b8d2-24c44d7f36f4",
          "f5ba2aba-f309-4572-b903-2e911824454a",
          "c729f088-f820-4fd6-a8a8-2eacef78de0c",
          "d6337bdb-993c-4455-8bcd-ff3625f2a5bf",
          "ab0233af-e49f-48de-9282-b749b65ef7b0",
          "71c61eb5-e18d-493d-9830-28b9a649f138",
          "4a31f650-cad0-4b49-85ca-ffcc85a2d3b0"
        ],
        "talentIds": [
          "398e92b9-aca2-414b-854b-6b46f936d1b4",
          "370ce0bf-e4f8-47e6-8d7b-028f6832a08f",
          "1cc74fb3-d554-44f2-b44e-18906ffa7d7b"
        ]
      },
      "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Tank",
        "name": "Guardian",
        "id": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f",
        "shortName": "Guard",
        "icon_name": "ability_racial_bearform",
        "spellIds": [
          "871b2db6-0bfb-412c-bee1-8949cd39c5ba",
          "424ab64d-26c8-498e-be27-104ecf25ad58"
        ],
        "talentIds": []
      },
      "8fceebcc-a93b-4692-81ea-331b2e59d43d": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "role": "Tank",
        "name": "Protection",
        "id": "8fceebcc-a93b-4692-81ea-331b2e59d43d",
        "shortName": "Prot",
        "icon_name": "ability_paladin_shieldofthetemplar",
        "spellIds": [
          "761c62aa-2b35-42b1-b79e-5cdba63ff4b7"
        ],
        "talentIds": []
      },
      "72947601-4270-4e1e-b917-25aacaa6d3e0": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Healer",
        "name": "Restoration",
        "id": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "shortName": "Resto",
        "icon_name": "spell_nature_healingtouch",
        "spellIds": [
          "2a2ca446-af05-4175-a096-20386178f628",
          "29b82d85-f01d-44b3-9a3d-a412e434ad7c",
          "e2034506-8be7-4043-847f-2df37fd09bd4",
          "a3840044-152d-4ad8-a4ce-703ebafd96d5"
        ],
        "talentIds": [
          "4b403fe4-2c35-4b0f-832c-770b5ce089cc",
          "fdb8022d-f199-48db-85e5-59e940100267"
        ]
      },
      "6c233e8c-5bd4-4ece-9fb8-529a1e78759b": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Ranged DPS",
        "name": "Balance",
        "id": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
        "shortName": "Balance",
        "icon_name": "spell_nature_starfall",
        "spellIds": [
          "775e7f51-767a-4d30-bb28-47264a8377fc",
          "8075ca44-e5c7-40c1-8ee3-1b253afc2f25"
        ],
        "talentIds": []
      },
      "b72fb4f9-413a-4222-8569-b3cb8e5e67f2": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "role": "Melee DPS",
        "name": "Frost",
        "id": "b72fb4f9-413a-4222-8569-b3cb8e5e67f2",
        "shortName": "Frost",
        "icon_name": "spell_deathknight_frostpresence",
        "spellIds": [
          "4d584836-442a-4c8a-8d6c-b47ec97f3d4a"
        ],
        "talentIds": []
      },
      "d122a0b5-d857-4bc5-a456-c7250f8f6690": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "role": "Healer",
        "name": "Holy",
        "id": "d122a0b5-d857-4bc5-a456-c7250f8f6690",
        "shortName": "Holy",
        "icon_name": "spell_holy_guardianspirit",
        "spellIds": [
          "75c64452-5926-42bd-9327-c0a5eb71fb3f",
          "65638ab9-b5c6-475f-8fe7-85d28d459575",
          "b3713050-b55f-4798-a16a-fddb69fe3120",
          "366fe5ef-19a8-49c8-bb26-875728f600f9"
        ],
        "talentIds": [
          "3590dcf1-d3e1-4b26-b168-b52dd4cf01cc"
        ]
      },
      "83b7651d-c296-4a15-9932-b4012144b6ec": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "role": "Tank",
        "name": "Protection",
        "id": "83b7651d-c296-4a15-9932-b4012144b6ec",
        "shortName": "Prot",
        "icon_name": "ability_warrior_defensivestance",
        "spellIds": [
          "08b4ddb7-406f-44d4-a1c4-aae2be6a498f"
        ],
        "talentIds": []
      },
      "1df0b300-a31e-4ebc-be57-a909f82bab4b": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "role": "Ranged DPS",
        "name": "Elemental",
        "id": "1df0b300-a31e-4ebc-be57-a909f82bab4b",
        "shortName": "Ele",
        "icon_name": "spell_nature_lightning",
        "spellIds": [
          "f15401db-7e78-4467-ad57-42ff2e1b8753",
          "d66fae11-272d-4c76-9c4a-357a08d6e487"
        ],
        "talentIds": [
          "30478e69-f51e-46aa-9423-e9ff1a8babf7"
        ]
      },
      "e1af3b62-ddf5-4369-a528-dab8ab94d366": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "role": "Healer",
        "name": "Holy",
        "id": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "shortName": "Holy",
        "icon_name": "spell_holy_holybolt",
        "spellIds": [
          "82251df1-96b5-457c-870b-7176512ee6ff",
          "60c0f350-f6a0-41db-ad3c-80323cd1eea6",
          "ce709f87-548e-4455-b6dc-70da08f0eca9",
          "2e557d61-9c22-4a95-a688-5fd72efa2051",
          "387a631e-5e9e-49d0-bfa7-9aad48304498"
        ],
        "talentIds": [
          "134af8c8-e90a-4105-a656-98d4fd5918d2",
          "dbb97a38-ec59-4ca4-ab34-948a9fff0cd3"
        ]
      },
      "e92b34bc-aa34-4579-a543-2ece2545d981": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "role": "Melee DPS",
        "name": "Arms",
        "id": "e92b34bc-aa34-4579-a543-2ece2545d981",
        "shortName": "Arms",
        "icon_name": "ability_warrior_savageblow",
        "spellIds": [
          "6a6d338d-4b84-4a50-a9e3-8f37662daeee"
        ],
        "talentIds": []
      },
      "4ac0a1e4-3352-49e9-b455-faa83312526d": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "role": "Melee DPS",
        "name": "Retribution",
        "id": "4ac0a1e4-3352-49e9-b455-faa83312526d",
        "shortName": "Ret",
        "icon_name": "spell_holy_auraoflight",
        "spellIds": [
          "657f81b5-3bd5-4c86-af1e-3e1d37fe7943"
        ],
        "talentIds": []
      },
      "08853913-0c47-4ca1-aec0-e93206a6ee45": {
        "classId": "122a0a6d-d523-4cc2-a743-f3d42d3e7f02",
        "role": "Melee DPS",
        "name": "Havoc",
        "id": "08853913-0c47-4ca1-aec0-e93206a6ee45",
        "shortName": "Havoc",
        "icon_name": "ability_demonhunter_specdps",
        "spellIds": [
          "f698c4ec-cfe8-42d2-ac6a-63ab648d8b9f"
        ],
        "talentIds": []
      },
      "51daa0f0-df16-4983-ae44-e11b5f9b3edb": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "role": "Healer",
        "name": "Restoration",
        "id": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "shortName": "Resto",
        "icon_name": "spell_nature_magicimmunity",
        "spellIds": [
          "709c5a8c-8039-41a8-9e92-c62e56f530bb",
          "e93d60aa-960d-4f9b-a346-3a9c72e98696",
          "94a6281b-669a-4ec8-b536-9671a4cf8bb2",
          "fa4b7232-7959-40b2-9393-b09fa336be43",
          "2d8388ea-9352-40f6-83a2-37fb350af203"
        ],
        "talentIds": [
          "d3b5d51c-cc70-4aba-80c0-b910b58afd3f",
          "f31ca468-6bc7-4e0d-a9fe-2d6dbf542c70",
          "45cf1a7d-ec60-4e32-84c6-0388ce7b414e"
        ]
      },
      "575905ae-cdc7-44c8-946c-861d50111b6d": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Melee DPS",
        "name": "Feral",
        "id": "575905ae-cdc7-44c8-946c-861d50111b6d",
        "shortName": "Feral",
        "icon_name": "ability_druid_catform",
        "spellIds": [
          "9efa4b56-0063-4717-840b-521fbb96e381",
          "122a4fb0-ec72-4c4b-8e5c-739eeee22f5f"
        ],
        "talentIds": []
      },
      "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "role": "Melee DPS",
        "name": "Enhancement",
        "id": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9",
        "shortName": "Enh",
        "icon_name": "spell_shaman_improvedstormstrike",
        "spellIds": [
          "c1ea1199-15d2-46ce-9b15-c070b86f2bef"
        ],
        "talentIds": []
      },
      "da2dc773-9412-4b11-ab2b-7d06e200b9d3": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "role": "Healer",
        "name": "Mistweaver",
        "id": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "shortName": "MW",
        "icon_name": "spell_monk_mistweaver_spec",
        "spellIds": [
          "fea0373e-a46e-417d-9d38-0c812350ef50",
          "362fa928-ce30-40cf-8e5c-ff5e188f16cd",
          "b4e34324-158e-478a-8100-971916bb763b"
        ],
        "talentIds": [
          "cd5bb2e8-c5c3-4d17-a3ee-c22a91f8ba6e"
        ]
      },
      "1b478900-c50e-49f6-b9b1-d2fedfb10c2b": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "role": "Melee DPS",
        "name": "Unholy",
        "id": "1b478900-c50e-49f6-b9b1-d2fedfb10c2b",
        "shortName": "Unholy",
        "icon_name": "spell_deathknight_unholypresence",
        "spellIds": [
          "6d1ac14a-3bd7-4ac7-97c5-3f023434634a"
        ],
        "talentIds": []
      },
      "34735ecf-bf9e-4225-bb6e-ee617b024b70": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "role": "Tank",
        "name": "Blood",
        "id": "34735ecf-bf9e-4225-bb6e-ee617b024b70",
        "shortName": "Blood",
        "icon_name": "spell_deathknight_bloodpresence",
        "spellIds": [
          "7a6b407c-b2d8-4f65-a5e0-9247f5031710"
        ],
        "talentIds": []
      },
      "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "role": "Melee DPS",
        "name": "Fury",
        "id": "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d",
        "shortName": "Fury",
        "icon_name": "ability_warrior_innerrage",
        "spellIds": [
          "847870d5-a2c0-4b77-858c-15eb23ccf968"
        ],
        "talentIds": []
      },
      "48c27d79-2cc2-4674-bfd0-9a471f6c7ced": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "role": "Ranged DPS",
        "name": "Shadow",
        "id": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced",
        "shortName": "Shadow",
        "icon_name": "spell_shadow_shadowwordpain",
        "spellIds": [
          "0376f7e6-dc7d-4892-af36-853f217c9c9a"
        ],
        "talentIds": []
      }
    },
    "patchInfo": {
      "buildVersion": "910_1"
    },
    "talentsById": {
      "f31ca468-6bc7-4e0d-a9fe-2d6dbf542c70": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Ancestral Protection Totem",
        "id": "f31ca468-6bc7-4e0d-a9fe-2d6dbf542c70",
        "shortName": "APT",
        "icon_name": "spell_nature_reincarnation",
        "game_id": 207399
      },
      "1cc74fb3-d554-44f2-b44e-18906ffa7d7b": {
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6",
        "name": "Mindbender",
        "id": "1cc74fb3-d554-44f2-b44e-18906ffa7d7b",
        "shortName": "Fiend",
        "icon_name": "spell_shadow_soulleech_3",
        "game_id": 123040
      },
      "cd5bb2e8-c5c3-4d17-a3ee-c22a91f8ba6e": {
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "name": "Invoke Chi-Ji, the Red Crane",
        "id": "cd5bb2e8-c5c3-4d17-a3ee-c22a91f8ba6e",
        "shortName": "Chi-ji",
        "icon_name": "inv_pet_cranegod",
        "game_id": 325197
      },
      "d3b5d51c-cc70-4aba-80c0-b910b58afd3f": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Wind Rush Totem",
        "id": "d3b5d51c-cc70-4aba-80c0-b910b58afd3f",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "134af8c8-e90a-4105-a656-98d4fd5918d2": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Holy Avenger",
        "id": "134af8c8-e90a-4105-a656-98d4fd5918d2",
        "shortName": "HA",
        "icon_name": "ability_paladin_holyavenger",
        "game_id": 105809
      },
      "4b403fe4-2c35-4b0f-832c-770b5ce089cc": {
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Incarnation: Tree of Life",
        "id": "4b403fe4-2c35-4b0f-832c-770b5ce089cc",
        "shortName": "Tree",
        "icon_name": "ability_druid_improvedtreeform",
        "game_id": 33891
      },
      "30478e69-f51e-46aa-9423-e9ff1a8babf7": {
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b",
        "name": "Ancestral Guidance",
        "id": "30478e69-f51e-46aa-9423-e9ff1a8babf7",
        "shortName": "Guide",
        "icon_name": "ability_shaman_ancestralguidance",
        "game_id": 108281
      },
      "370ce0bf-e4f8-47e6-8d7b-028f6832a08f": {
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6",
        "name": "Evangelism",
        "id": "370ce0bf-e4f8-47e6-8d7b-028f6832a08f",
        "shortName": "Evan",
        "icon_name": "spell_holy_divineillumination",
        "game_id": 246287
      },
      "fdb8022d-f199-48db-85e5-59e940100267": {
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Inner Peace",
        "id": "fdb8022d-f199-48db-85e5-59e940100267",
        "shortName": "IP",
        "icon_name": "ability_druid_dreamstate",
        "game_id": 197073
      },
      "3590dcf1-d3e1-4b26-b168-b52dd4cf01cc": {
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690",
        "name": "Holy Word: Salvation",
        "id": "3590dcf1-d3e1-4b26-b168-b52dd4cf01cc",
        "shortName": "Salv",
        "icon_name": "ability_priest_archangel",
        "game_id": 265202
      },
      "398e92b9-aca2-414b-854b-6b46f936d1b4": {
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6",
        "name": "Spirit Shell",
        "id": "398e92b9-aca2-414b-854b-6b46f936d1b4",
        "shortName": "Shell",
        "icon_name": "ability_shaman_astralshift",
        "game_id": 109964
      },
      "45cf1a7d-ec60-4e32-84c6-0388ce7b414e": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Ascendance",
        "id": "45cf1a7d-ec60-4e32-84c6-0388ce7b414e",
        "shortName": "Asc",
        "icon_name": "spell_fire_elementaldevastation",
        "game_id": 114052
      },
      "dbb97a38-ec59-4ca4-ab34-948a9fff0cd3": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Avenging Crusader",
        "id": "dbb97a38-ec59-4ca4-ab34-948a9fff0cd3",
        "shortName": "Crusa",
        "icon_name": "ability_paladin_veneration",
        "game_id": 216331
      }
    },
    "spellsById": {
      "e93d60aa-960d-4f9b-a346-3a9c72e98696": {
        "affectedByModifierIds": [],
        "name": "Healing Tide Totem",
        "cooldown": 180,
        "id": "e93d60aa-960d-4f9b-a346-3a9c72e98696",
        "shortName": "HTT",
        "icon_name": "ability_shaman_healingtide",
        "game_id": 108280
      },
      "6a6d338d-4b84-4a50-a9e3-8f37662daeee": {
        "affectedByModifierIds": [],
        "name": "Rallying Cry",
        "cooldown": 180,
        "id": "6a6d338d-4b84-4a50-a9e3-8f37662daeee",
        "shortName": "RC",
        "icon_name": "ability_warrior_rallyingcry",
        "game_id": 97462
      },
      "775e7f51-767a-4d30-bb28-47264a8377fc": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "775e7f51-767a-4d30-bb28-47264a8377fc",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "f15401db-7e78-4467-ad57-42ff2e1b8753": {
        "affectedByModifierIds": [],
        "talentId": "30478e69-f51e-46aa-9423-e9ff1a8babf7",
        "name": "Ancestral Guidance",
        "cooldown": 120,
        "id": "f15401db-7e78-4467-ad57-42ff2e1b8753",
        "shortName": "Guide",
        "icon_name": "ability_shaman_ancestralguidance",
        "game_id": 108281
      },
      "96c97815-252d-401a-b8d2-24c44d7f36f4": {
        "affectedByModifierIds": [],
        "name": "Power Word: Barrier",
        "cooldown": 180,
        "id": "96c97815-252d-401a-b8d2-24c44d7f36f4",
        "shortName": "PW:B",
        "icon_name": "spell_holy_powerwordbarrier",
        "game_id": 62618
      },
      "387a631e-5e9e-49d0-bfa7-9aad48304498": {
        "affectedByModifierIds": [],
        "talentId": "dbb97a38-ec59-4ca4-ab34-948a9fff0cd3",
        "name": "Avenging Crusader",
        "cooldown": 120,
        "id": "387a631e-5e9e-49d0-bfa7-9aad48304498",
        "shortName": "Crusa",
        "icon_name": "ability_paladin_veneration",
        "game_id": 216331
      },
      "d6337bdb-993c-4455-8bcd-ff3625f2a5bf": {
        "affectedByModifierIds": [],
        "name": "Shadowfiend",
        "cooldown": 180,
        "id": "d6337bdb-993c-4455-8bcd-ff3625f2a5bf",
        "shortName": "Fiend",
        "replacedByTalentId": "1cc74fb3-d554-44f2-b44e-18906ffa7d7b",
        "icon_name": "spell_shadow_shadowfiend",
        "game_id": 34433
      },
      "847870d5-a2c0-4b77-858c-15eb23ccf968": {
        "affectedByModifierIds": [],
        "name": "Rallying Cry",
        "cooldown": 180,
        "id": "847870d5-a2c0-4b77-858c-15eb23ccf968",
        "shortName": "RC",
        "icon_name": "ability_warrior_rallyingcry",
        "game_id": 97462
      },
      "ab0233af-e49f-48de-9282-b749b65ef7b0": {
        "affectedByModifierIds": [],
        "talentId": "398e92b9-aca2-414b-854b-6b46f936d1b4",
        "name": "Spirit Shell",
        "cooldown": 90,
        "id": "ab0233af-e49f-48de-9282-b749b65ef7b0",
        "shortName": "Shell",
        "icon_name": "ability_shaman_astralshift",
        "game_id": 109964
      },
      "2e557d61-9c22-4a95-a688-5fd72efa2051": {
        "affectedByModifierIds": [],
        "name": "Ashen Hallow",
        "cooldown": 240,
        "modifierId": "bbbc72a1-29d5-4e1f-9cf6-997aae307dcf",
        "id": "2e557d61-9c22-4a95-a688-5fd72efa2051",
        "shortName": "AH",
        "icon_name": "ability_revendreth_paladin",
        "game_id": 316958
      },
      "4d584836-442a-4c8a-8d6c-b47ec97f3d4a": {
        "affectedByModifierIds": [],
        "name": "Anti-Magic Zone",
        "cooldown": 120,
        "id": "4d584836-442a-4c8a-8d6c-b47ec97f3d4a",
        "shortName": "AMZ",
        "icon_name": "spell_deathknight_antimagiczone",
        "game_id": 51052
      },
      "65638ab9-b5c6-475f-8fe7-85d28d459575": {
        "affectedByModifierIds": [],
        "name": "Symbol of Hope",
        "cooldown": 300,
        "id": "65638ab9-b5c6-475f-8fe7-85d28d459575",
        "shortName": "Hope",
        "icon_name": "spell_holy_symbolofhope",
        "game_id": 64901
      },
      "2a2ca446-af05-4175-a096-20386178f628": {
        "affectedByModifierIds": [],
        "name": "Tranquility",
        "cooldown": 180,
        "id": "2a2ca446-af05-4175-a096-20386178f628",
        "shortName": "Tranq",
        "icon_name": "spell_nature_tranquility",
        "game_id": 740
      },
      "8075ca44-e5c7-40c1-8ee3-1b253afc2f25": {
        "affectedByModifierIds": [
          "d55d03da-62a4-4a69-af5a-23c98b30d7e8"
        ],
        "name": "Convoke the Spirits",
        "cooldown": 120,
        "modifierId": "04eb6506-514b-48be-9789-2dd25e68eb16",
        "id": "8075ca44-e5c7-40c1-8ee3-1b253afc2f25",
        "shortName": "Con",
        "icon_name": "ability_ardenweald_druid",
        "game_id": 323764
      },
      "75c64452-5926-42bd-9327-c0a5eb71fb3f": {
        "affectedByModifierIds": [],
        "name": "Divine Hymn",
        "cooldown": 180,
        "id": "75c64452-5926-42bd-9327-c0a5eb71fb3f",
        "shortName": "Hymn",
        "icon_name": "spell_holy_divinehymn",
        "game_id": 64843
      },
      "871b2db6-0bfb-412c-bee1-8949cd39c5ba": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 60,
        "id": "871b2db6-0bfb-412c-bee1-8949cd39c5ba",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "e2034506-8be7-4043-847f-2df37fd09bd4": {
        "affectedByModifierIds": [
          "d55d03da-62a4-4a69-af5a-23c98b30d7e8"
        ],
        "name": "Convoke the Spirits",
        "cooldown": 120,
        "modifierId": "04eb6506-514b-48be-9789-2dd25e68eb16",
        "id": "e2034506-8be7-4043-847f-2df37fd09bd4",
        "shortName": "Con",
        "icon_name": "ability_ardenweald_druid",
        "game_id": 323764
      },
      "362fa928-ce30-40cf-8e5c-ff5e188f16cd": {
        "affectedByModifierIds": [],
        "name": "Revival",
        "cooldown": 180,
        "id": "362fa928-ce30-40cf-8e5c-ff5e188f16cd",
        "shortName": "Rev",
        "icon_name": "spell_monk_revival",
        "game_id": 115310
      },
      "709c5a8c-8039-41a8-9e92-c62e56f530bb": {
        "affectedByModifierIds": [],
        "talentId": "d3b5d51c-cc70-4aba-80c0-b910b58afd3f",
        "name": "Wind Rush Totem",
        "cooldown": 120,
        "id": "709c5a8c-8039-41a8-9e92-c62e56f530bb",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "761c62aa-2b35-42b1-b79e-5cdba63ff4b7": {
        "affectedByModifierIds": [],
        "name": "Ashen Hallow",
        "cooldown": 240,
        "modifierId": "bbbc72a1-29d5-4e1f-9cf6-997aae307dcf",
        "id": "761c62aa-2b35-42b1-b79e-5cdba63ff4b7",
        "shortName": "AH",
        "icon_name": "ability_revendreth_paladin",
        "game_id": 316958
      },
      "6d1ac14a-3bd7-4ac7-97c5-3f023434634a": {
        "affectedByModifierIds": [],
        "name": "Anti-Magic Zone",
        "cooldown": 120,
        "id": "6d1ac14a-3bd7-4ac7-97c5-3f023434634a",
        "shortName": "AMZ",
        "icon_name": "spell_deathknight_antimagiczone",
        "game_id": 51052
      },
      "94a6281b-669a-4ec8-b536-9671a4cf8bb2": {
        "affectedByModifierIds": [],
        "talentId": "45cf1a7d-ec60-4e32-84c6-0388ce7b414e",
        "name": "Ascendance",
        "cooldown": 180,
        "id": "94a6281b-669a-4ec8-b536-9671a4cf8bb2",
        "shortName": "Asc",
        "icon_name": "spell_fire_elementaldevastation",
        "game_id": 114052
      },
      "08b4ddb7-406f-44d4-a1c4-aae2be6a498f": {
        "affectedByModifierIds": [],
        "name": "Rallying Cry",
        "cooldown": 180,
        "id": "08b4ddb7-406f-44d4-a1c4-aae2be6a498f",
        "shortName": "RC",
        "icon_name": "ability_warrior_rallyingcry",
        "game_id": 97462
      },
      "4a31f650-cad0-4b49-85ca-ffcc85a2d3b0": {
        "affectedByModifierIds": [],
        "talentId": "1cc74fb3-d554-44f2-b44e-18906ffa7d7b",
        "name": "Mindbender",
        "cooldown": 60,
        "id": "4a31f650-cad0-4b49-85ca-ffcc85a2d3b0",
        "shortName": "Fiend",
        "icon_name": "spell_shadow_soulleech_3",
        "game_id": 123040
      },
      "29b82d85-f01d-44b3-9a3d-a412e434ad7c": {
        "affectedByModifierIds": [],
        "talentId": "4b403fe4-2c35-4b0f-832c-770b5ce089cc",
        "name": "Incarnation: Tree of Life",
        "cooldown": 180,
        "id": "29b82d85-f01d-44b3-9a3d-a412e434ad7c",
        "shortName": "Tree",
        "icon_name": "ability_druid_improvedtreeform",
        "game_id": 33891
      },
      "f5ba2aba-f309-4572-b903-2e911824454a": {
        "affectedByModifierIds": [],
        "talentId": "370ce0bf-e4f8-47e6-8d7b-028f6832a08f",
        "name": "Evangelism",
        "cooldown": 90,
        "id": "f5ba2aba-f309-4572-b903-2e911824454a",
        "shortName": "Evan",
        "icon_name": "spell_holy_divineillumination",
        "game_id": 246287
      },
      "b4e34324-158e-478a-8100-971916bb763b": {
        "affectedByModifierIds": [],
        "name": "Invoke Yu'lon, the Jade Serpent",
        "cooldown": 180,
        "id": "b4e34324-158e-478a-8100-971916bb763b",
        "shortName": "Yulon",
        "icon_name": "ability_monk_dragonkick",
        "game_id": 322118
      },
      "60c0f350-f6a0-41db-ad3c-80323cd1eea6": {
        "affectedByModifierIds": [],
        "name": "Avenging Wrath",
        "cooldown": 120,
        "id": "60c0f350-f6a0-41db-ad3c-80323cd1eea6",
        "shortName": "Wings",
        "icon_name": "spell_holy_avenginewrath",
        "game_id": 31884
      },
      "9efa4b56-0063-4717-840b-521fbb96e381": {
        "affectedByModifierIds": [
          "d55d03da-62a4-4a69-af5a-23c98b30d7e8"
        ],
        "name": "Convoke the Spirits",
        "cooldown": 120,
        "modifierId": "04eb6506-514b-48be-9789-2dd25e68eb16",
        "id": "9efa4b56-0063-4717-840b-521fbb96e381",
        "shortName": "Con",
        "icon_name": "ability_ardenweald_druid",
        "game_id": 323764
      },
      "a3840044-152d-4ad8-a4ce-703ebafd96d5": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "a3840044-152d-4ad8-a4ce-703ebafd96d5",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "b3713050-b55f-4798-a16a-fddb69fe3120": {
        "affectedByModifierIds": [],
        "talentId": "3590dcf1-d3e1-4b26-b168-b52dd4cf01cc",
        "name": "Holy Word: Salvation",
        "cooldown": 720,
        "id": "b3713050-b55f-4798-a16a-fddb69fe3120",
        "shortName": "Salv",
        "icon_name": "ability_priest_archangel",
        "game_id": 265202
      },
      "366fe5ef-19a8-49c8-bb26-875728f600f9": {
        "affectedByModifierIds": [],
        "name": "Boon of the Ascended",
        "cooldown": 180,
        "modifierId": "6a4705a0-dd2a-4010-a1cc-2514cc30ed94",
        "id": "366fe5ef-19a8-49c8-bb26-875728f600f9",
        "shortName": "Boon",
        "icon_name": "ability_bastion_priest",
        "game_id": 325013
      },
      "122a4fb0-ec72-4c4b-8e5c-739eeee22f5f": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "122a4fb0-ec72-4c4b-8e5c-739eeee22f5f",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "2d8388ea-9352-40f6-83a2-37fb350af203": {
        "affectedByModifierIds": [],
        "talentId": "f31ca468-6bc7-4e0d-a9fe-2d6dbf542c70",
        "name": "Ancestral Protection Totem",
        "cooldown": 300,
        "id": "2d8388ea-9352-40f6-83a2-37fb350af203",
        "shortName": "APT",
        "icon_name": "spell_nature_reincarnation",
        "game_id": 207399
      },
      "82251df1-96b5-457c-870b-7176512ee6ff": {
        "affectedByModifierIds": [],
        "name": "Aura Mastery",
        "cooldown": 180,
        "id": "82251df1-96b5-457c-870b-7176512ee6ff",
        "shortName": "AM",
        "icon_name": "spell_holy_auramastery",
        "game_id": 31821
      },
      "ce709f87-548e-4455-b6dc-70da08f0eca9": {
        "affectedByModifierIds": [],
        "talentId": "134af8c8-e90a-4105-a656-98d4fd5918d2",
        "name": "Holy Avenger",
        "cooldown": 180,
        "id": "ce709f87-548e-4455-b6dc-70da08f0eca9",
        "shortName": "HA",
        "icon_name": "ability_paladin_holyavenger",
        "game_id": 105809
      },
      "d66fae11-272d-4c76-9c4a-357a08d6e487": {
        "affectedByModifierIds": [],
        "talentId": "d3b5d51c-cc70-4aba-80c0-b910b58afd3f",
        "name": "Wind Rush Totem",
        "cooldown": 120,
        "id": "d66fae11-272d-4c76-9c4a-357a08d6e487",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "c1ea1199-15d2-46ce-9b15-c070b86f2bef": {
        "affectedByModifierIds": [],
        "talentId": "d3b5d51c-cc70-4aba-80c0-b910b58afd3f",
        "name": "Wind Rush Totem",
        "cooldown": 120,
        "id": "c1ea1199-15d2-46ce-9b15-c070b86f2bef",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "657f81b5-3bd5-4c86-af1e-3e1d37fe7943": {
        "affectedByModifierIds": [],
        "name": "Ashen Hallow",
        "cooldown": 240,
        "modifierId": "bbbc72a1-29d5-4e1f-9cf6-997aae307dcf",
        "id": "657f81b5-3bd5-4c86-af1e-3e1d37fe7943",
        "shortName": "AH",
        "icon_name": "ability_revendreth_paladin",
        "game_id": 316958
      },
      "0376f7e6-dc7d-4892-af36-853f217c9c9a": {
        "affectedByModifierIds": [],
        "name": "Vampiric Embrace",
        "cooldown": 120,
        "id": "0376f7e6-dc7d-4892-af36-853f217c9c9a",
        "shortName": "VE",
        "icon_name": "spell_shadow_unsummonbuilding",
        "game_id": 15286
      },
      "7a6b407c-b2d8-4f65-a5e0-9247f5031710": {
        "affectedByModifierIds": [],
        "name": "Anti-Magic Zone",
        "cooldown": 120,
        "id": "7a6b407c-b2d8-4f65-a5e0-9247f5031710",
        "shortName": "AMZ",
        "icon_name": "spell_deathknight_antimagiczone",
        "game_id": 51052
      },
      "71c61eb5-e18d-493d-9830-28b9a649f138": {
        "affectedByModifierIds": [],
        "name": "Boon of the Ascended",
        "cooldown": 180,
        "modifierId": "6a4705a0-dd2a-4010-a1cc-2514cc30ed94",
        "id": "71c61eb5-e18d-493d-9830-28b9a649f138",
        "shortName": "Boon",
        "icon_name": "ability_bastion_priest",
        "game_id": 325013
      },
      "c729f088-f820-4fd6-a8a8-2eacef78de0c": {
        "affectedByModifierIds": [],
        "name": "Rapture",
        "cooldown": 90,
        "id": "c729f088-f820-4fd6-a8a8-2eacef78de0c",
        "shortName": "Rapt",
        "replacedByTalentId": "398e92b9-aca2-414b-854b-6b46f936d1b4",
        "icon_name": "spell_holy_rapture",
        "game_id": 47536
      },
      "fea0373e-a46e-417d-9d38-0c812350ef50": {
        "affectedByModifierIds": [],
        "talentId": "cd5bb2e8-c5c3-4d17-a3ee-c22a91f8ba6e",
        "name": "Invoke Chi-Ji, the Red Crane",
        "cooldown": 180,
        "id": "fea0373e-a46e-417d-9d38-0c812350ef50",
        "shortName": "Chi-ji",
        "icon_name": "inv_pet_cranegod",
        "game_id": 325197
      },
      "f698c4ec-cfe8-42d2-ac6a-63ab648d8b9f": {
        "affectedByModifierIds": [],
        "name": "Darkness",
        "cooldown": 180,
        "id": "f698c4ec-cfe8-42d2-ac6a-63ab648d8b9f",
        "shortName": "Dark",
        "icon_name": "ability_demonhunter_darkness",
        "game_id": 196718
      },
      "fa4b7232-7959-40b2-9393-b09fa336be43": {
        "affectedByModifierIds": [],
        "name": "Spirit Link Totem",
        "cooldown": 180,
        "id": "fa4b7232-7959-40b2-9393-b09fa336be43",
        "shortName": "SLT",
        "icon_name": "spell_shaman_spiritlink",
        "game_id": 98008
      },
      "424ab64d-26c8-498e-be27-104ecf25ad58": {
        "affectedByModifierIds": [
          "d55d03da-62a4-4a69-af5a-23c98b30d7e8"
        ],
        "name": "Convoke the Spirits",
        "cooldown": 120,
        "modifierId": "04eb6506-514b-48be-9789-2dd25e68eb16",
        "id": "424ab64d-26c8-498e-be27-104ecf25ad58",
        "shortName": "Con",
        "icon_name": "ability_ardenweald_druid",
        "game_id": 323764
      }
    },
    "changelog": [
      "- Spirit Shell is now a 1.5min CD instead of 1min",
      "- Added Ashen Hallow for Holy Paladins only",
      "- Added Symbol of Hope"
    ],
    "modifiersById": {
      "bbbc72a1-29d5-4e1f-9cf6-997aae307dcf": {
        "meta": "",
        "name": "Ashen Hallow",
        "id": "bbbc72a1-29d5-4e1f-9cf6-997aae307dcf",
        "shortName": "AH",
        "eligibleSpecIds": [
          "4ac0a1e4-3352-49e9-b455-faa83312526d",
          "8fceebcc-a93b-4692-81ea-331b2e59d43d",
          "e1af3b62-ddf5-4369-a528-dab8ab94d366"
        ],
        "icon_name": "ability_revendreth_paladin",
        "game_id": 316958
      },
      "d55d03da-62a4-4a69-af5a-23c98b30d7e8": {
        "meta": "",
        "name": "Celestial Spirits",
        "id": "d55d03da-62a4-4a69-af5a-23c98b30d7e8",
        "shortName": "Celest",
        "eligibleSpecIds": [
          "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f",
          "72947601-4270-4e1e-b917-25aacaa6d3e0",
          "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
          "575905ae-cdc7-44c8-946c-861d50111b6d"
        ],
        "icon_name": "ability_ardenweald_druid",
        "game_id": 354118
      },
      "04eb6506-514b-48be-9789-2dd25e68eb16": {
        "meta": "",
        "name": "Convoke the Spirits",
        "id": "04eb6506-514b-48be-9789-2dd25e68eb16",
        "shortName": "Con",
        "eligibleSpecIds": [
          "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f",
          "72947601-4270-4e1e-b917-25aacaa6d3e0",
          "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
          "575905ae-cdc7-44c8-946c-861d50111b6d"
        ],
        "icon_name": "ability_ardenweald_druid",
        "game_id": 323764
      },
      "6a4705a0-dd2a-4010-a1cc-2514cc30ed94": {
        "meta": "",
        "name": "Boon of the Ascended",
        "id": "6a4705a0-dd2a-4010-a1cc-2514cc30ed94",
        "shortName": "Boon",
        "eligibleSpecIds": [
          "67a45712-192e-4916-ad57-d9a13124fea6",
          "d122a0b5-d857-4bc5-a456-c7250f8f6690"
        ],
        "icon_name": "ability_bastion_priest",
        "game_id": 325013
      }
    }
  }
`)
